import { hardwareDataActions } from "./hardwaredata-slice";

export const fetchHardwareData = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch("../../json/hardware.json", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("couldn't fetch Product data");
      }
      const data = await response.json();
      return data;
    };
    const hardwareData = await fetchData();
    dispatch(hardwareDataActions.getHardware(hardwareData.product));
  };
};
